// ===================================================
// constants/index.js — 앱 전역 상수 모음
//
// 여러 컴포넌트에서 동일하게 사용하는 상수들을 여기서 관리합니다.
// 값을 바꿀 때 이 파일 한 곳만 수정하면 됩니다.
// ===================================================

// 앱에서 제공하는 기록 모드 목록 (표시 순서)
export const MODES = ['diary', 'decision', 'dream', 'note', 'planner'];

// 현재 이야기하기 화면에서 활성화된 모드 (나머지는 임시 비활성)
export const ACTIVE_MODES = ['diary', 'decision', 'dream'];

// 자유 기록(freewrite)을 지원하는 모드
export const FREEWRITE_MODES = ['diary', 'note', 'decision', 'dream'];

// 자유 기록 최대 글자 수
export const FREEWRITE_MAX_LENGTH = 5000;
